const sanitizePrefillValue = (value) => String(value || "").trim();

export const getLoginPrefillFromEnv = () => ({
  project: sanitizePrefillValue(import.meta.env.VITE_LOGIN_PREFILL_PROJECT),
  email: sanitizePrefillValue(import.meta.env.VITE_LOGIN_PREFILL_EMAIL),
  password: sanitizePrefillValue(import.meta.env.VITE_LOGIN_PREFILL_PASSWORD),
});
